import { Directive, OnInit, Optional } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import type { Options } from '@popperjs/core';

@Directive({
	selector: '[appDownloadPopoverOptions][ngbPopover]'
})
export class DownloadPopoverOptionsDirective implements OnInit {
	constructor(@Optional() private readonly popover: NgbPopover) {}

	ngOnInit(): void {
		if (!this.popover) {
			return;
		}

		this.popover.popperOptions = (options: Partial<Options>): Partial<Options> => ({
			...options,
			modifiers: [
				...(options.modifiers ?? []).filter(modifier => modifier.name !== 'computeStyles'),
				{
					name: 'computeStyles',
					options: {
						adaptive: false,
						gpuAcceleration: false
					}
				}
			]
		});
	}
}
